import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'

export default function useGenResourcesLinks({
  nonReligiousMode,
  isNonEnCoreLanguage,
  isCoreLanguage,
  canAddPersonalData,
}) {
  const { t } = useTranslation()

  return {
    id: 'genResources',
    title: t('nav.genResources', 'Genealogy Resources'),
    subNav: [
      {
        id: 'obituaries',
        text: t('nav.links.genResources.obituaries', 'Obituaries'),
        url: `/${i18n.language}/blog/tips-to-find-obituary-specific-person/`,
        linkName: 'ff_genRsrcs_obituaries',
        dataTestId: 'ff_obituaries',
        isNew: false,
        hidden: nonReligiousMode || isNonEnCoreLanguage || !isCoreLanguage,
      },
      {
        id: 'cemeteries',
        text: t('nav.links.genResources.cemeteries', 'Cemeteries'),
        url: `/${i18n.language}/cemeteries`,
        linkName: 'ff_genRsrcs_cemeteries',
        dataTestId: 'ff_cemeteries',
        isNew: false,
      },
      {
        id: 'fsCatalog',
        text: t('nav.links.genResources.fsCatalog', 'FamilySearch Catalog'),
        url: '/search/catalog',
        linkName: 'ff_genRsrcs_fsCatalog',
        dataTestId: 'ff_fs_catalog',
        isNew: false,
      },
      {
        id: 'ancestorSrch',
        text: t('nav.links.genResources.ancestorSrch', 'Ancestor Search'),
        url: `https://ancestors.familysearch.org/${i18n.language}/`,
        linkName: 'ff_genRsrcs_ancestorSrch',
        dataTestId: 'ff_ancestor_search',
        isNew: false,
        hidden: !canAddPersonalData,
      },
      {
        id: 'genSrch',
        text: t('nav.links.genResources.genSrch', 'Genealogy Search'),
        url: '/search/discovery/',
        linkName: 'ff_genRsrcs_genSrch',
        dataTestId: 'ff_genealogy_search',
        isNew: false,
        hidden: !canAddPersonalData,
      },
      {
        id: 'placeNames',
        text: t('nav.links.genResources.placeNames', 'Place Names'),
        url: '/research/places/',
        linkName: 'ff_genRsrcs_placeNames',
        dataTestId: 'ff_place_names',
        isNew: false,
        hidden: !isCoreLanguage,
      },
      {
        id: 'guidedRsrch',
        text: t('nav.links.genResources.guidedRsrch', 'Guided Research'),
        url: `/${i18n.language}/wiki/Guided_Research_for_Online_Records`,
        linkName: 'ff_genRcs_guidedRsrch',
        dataTestId: 'ff_guided_research',
        isNew: false,
        hidden: nonReligiousMode || isNonEnCoreLanguage || !isCoreLanguage,
      },
      {
        id: 'books',
        text: t('nav.links.genResources.books', 'Digital Books'),
        url: 'https://www.familysearch.org/library/books/' /* Prod link since this is not on beta */,
        linkName: 'ff_genRsrcs_books',
        dataTestId: 'ff_digital_books',
        isNew: false,
        hidden: nonReligiousMode || isNonEnCoreLanguage || !isCoreLanguage,
      },
      {
        id: '1950Census',
        text: t('nav.links.involved.1950Census', '1950 U.S. Census'),
        url: '/1950census/',
        linkName: 'ff_inv_1950Census',
        dataTestId: 'ff_1950_census',
        isNew: false,
        hidden: nonReligiousMode || !isCoreLanguage || !canAddPersonalData,
      },
    ],
  }
}
